import { forwardRef } from "react";
function SvgRawAddTextSetIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#1D1D1D"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 10h18v18H4z"
      />
      <path
        stroke="#1D1D1D"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 4h18v18h-6V10H10V4Z"
      />
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeWidth={2}
        d="M10 19h6m-3 3v-6"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawAddTextSetIcon);
export default ForwardRef;
